<template>
  <div class="legal-page">
    <NavBar />
    
    <div class="page-body">
      <!-- 面包屑 -->
      <div class="breadcrumb">
        <span class="crumb" @click="$router.push('/')">首页</span>
        <span class="sep">&gt;</span>
        <span class="crumb current">{{ pageData.title || '加载中...' }}</span>
      </div>
      
      <div class="content-wrap">
        <!-- 加载中 -->
        <div v-if="loading" class="loading-box">
          <a-skeleton :animation="true">
            <a-skeleton-line :rows="1" :widths="['30%']" />
            <a-skeleton-line :rows="12" :style="{ marginTop: '20px' }" />
          </a-skeleton>
        </div>
        
        <!-- 内容 -->
        <template v-else-if="pageData.content">
          <h1 class="page-title">{{ pageData.title }}</h1>
          <article class="page-content" v-html="pageData.content"></article>
        </template>
        
        <!-- 空状态 -->
        <div v-else class="empty-box">
          <div class="empty-text">页面内容不存在</div>
          <button class="back-btn" @click="$router.push('/')">返回首页</button>
        </div>
      </div>
    </div>
    
    <Footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import { getPageDetail } from '@/api/index.js'

export default {
  name: 'LegalPage',
  components: {
    NavBar,
    Footer
  },
  data() {
    return {
      loading: true,
      pageData: {}
    }
  },
  watch: {
    '$route.params.type': {
      immediate: true,
      handler() {
        this.loadPageContent()
      }
    }
  },
  methods: {
    async loadPageContent() {
      this.loading = true
      try {
        const type = this.$route.params.type
        const result = await getPageDetail(type)
        if (result.code === 1 && result.data) {
          this.pageData = result.data
        } else {
          this.pageData = {}
        }
      } catch (error) {
        console.error('加载页面内容失败:', error)
        this.pageData = {}
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f0f2f5;
}

.page-body {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 16px 50px;
}

/* 面包屑 */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  font-size: 14px;
  color: #666;
}

.crumb {
  cursor: pointer;
}

.crumb:hover:not(.current) {
  color: #1890ff;
}

.crumb.current {
  color: #333;
  cursor: default;
}

.sep {
  color: #ccc;
}

/* 内容区 */
.content-wrap {
  background: #fff;
  border-radius: 4px;
  padding: 32px;
  min-height: 400px;
}

.loading-box {
  padding: 20px 0;
}

/* 标题 */
.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #222;
  margin: 0 0 24px 0;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}

/* 正文 */
.page-content {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
}

.page-content :deep(h1) {
  font-size: 22px;
  font-weight: 600;
  color: #222;
  margin: 28px 0 14px;
}

.page-content :deep(h2) {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin: 24px 0 12px;
}

.page-content :deep(h3) {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 20px 0 10px;
}

.page-content :deep(p) {
  margin-bottom: 14px;
}

.page-content :deep(ul),
.page-content :deep(ol) {
  margin: 14px 0;
  padding-left: 24px;
}

.page-content :deep(li) {
  margin-bottom: 8px;
}

.page-content :deep(strong) {
  color: #222;
  font-weight: 600;
}

.page-content :deep(a) {
  color: #1890ff;
}

.page-content :deep(a:hover) {
  text-decoration: underline;
}

.page-content :deep(blockquote) {
  margin: 16px 0;
  padding: 12px 16px;
  background: #fafafa;
  border-left: 3px solid #ddd;
  color: #666;
}

.page-content :deep(table) {
  width: 100%;
  margin: 16px 0;
  border-collapse: collapse;
}

.page-content :deep(th),
.page-content :deep(td) {
  padding: 10px 12px;
  border: 1px solid #e8e8e8;
  text-align: left;
}

.page-content :deep(th) {
  background: #fafafa;
  font-weight: 600;
}

/* 空状态 */
.empty-box {
  text-align: center;
  padding: 60px 0;
}

.empty-text {
  font-size: 15px;
  color: #999;
  margin-bottom: 20px;
}

.back-btn {
  padding: 8px 24px;
  font-size: 14px;
  color: #fff;
  background: #1890ff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.back-btn:hover {
  background: #40a9ff;
}

/* 响应式 */
@media (max-width: 768px) {
  .content-wrap {
    padding: 20px 16px;
  }
  
  .page-title {
    font-size: 20px;
  }
  
  .page-content {
    font-size: 14px;
  }
  
  .page-content :deep(h1) {
    font-size: 18px;
  }
  
  .page-content :deep(h2) {
    font-size: 16px;
  }
}
</style>
